import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { IconName } from '@optimus-web/icons';
import { TooltippedIconButton } from '@mews-commander/ui';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { startEntityDeleting } from '../actions';

interface EntityDeleteButtonProps {
    id: string;
    scope: string;
}

export const EntityDeleteButton = ({ id, scope }: EntityDeleteButtonProps) => {
    const dispatch = useCommanderThunkDispatch();
    return (
        <TooltippedIconButton
            icon={IconName.Delete}
            size="small"
            variant="ghost"
            onClick={() => dispatch(startEntityDeleting(id, scope))}
            tooltip={<LocalizedText textKey={TextKey.Delete} />}
            type="submit"
        />
    );
};
